import { Environment, l10n } from './shared.models';

export const environment: Environment = {
  production: false,
  devTools: true,
  hmr: false,
  name: 'development-na',
  authEnv: 'development',
  appUrl: 'https://maps.dev.zonarsystems.net',
  useSettingsApi: false,
  datadog: {
    applicationId: '6f9abbe4-1e1f-4150-b7d9-5f5bef0cb1c0',
    clientToken: 'pub9e3e901f623850797e3a6ece6bf4efda',
    tagEnvironment: 'development'
  },
  devCycle: {
    clientId: 'dvc_client_08470c3a_5461_468e_98e9_3a65f3e3a2db_c1b538c'
  },
  here: {
    apiKeyV3: 'K9sFEK271qD8JFibP_1Dk9u2IQqiTXsxsv9T11PaKng'
  },
  openweathermap: {
    apiKey: '254ea8b8424b73b6afb17b2835b436f3',
    opacity: 0.4
  },
  googleTagManager: {
    id: 'GTM-PM9R42P',
    auth: '4-KiGGwpt35kxwSPey_o-w',
    environment: 'env-3'
  },
  auth: {
    clientID: 'uj6VIFOORnKvvDhvl5DIjJLdVfjFvMI5',
    domain: 'zonar-dev.auth0.com',
    audience: 'http://apidev.zonarsystems.net/',
    applicationId: '0961d523-ef76-489a-8613-e0e639d5b233',
    useRefreshTokens: true,
    maxAge: 36000
  },
  userPreferenceApiBase: {
    url: 'https://api-dev.zonarsystems.net/alert/v1'
  },
  locationApi: {
    url: 'https://location-writer-db.dev.zonarsystems.net',
    assetPropertiesUrl: 'https://location-writer-db.dev.zonarsystems.net'
  },
  autocompleteApi: {
    url: 'https://zonar-nonprod-dev.apigee.net/location-api/autocomplete',
    pageSize: 10
  },
  apiBase: {
    url: 'https://zonar-nonprod-dev.apigee.net'
  },
  coreEntityApiBase: {
    url: 'https://api-dev.zonarsystems.net/core/v1'
  },
  historicalApiBase: {
    url: 'https://gtcx-historical-api.dev.zonarsystems.net/api/v1'
  },
  dataUpdateMessages: {
    // units are minutes
    updateInterval: 1,
    idling: 60 * 12,
    notIdling: 15
  },
  nearbyAssets: {
    searchRadiusMeters: 50 * 1609, // 50 miles in meters
    assetsToReturn: 10
  },
  liveUpdate: {
    pageSize: 150,
    pollingInterval: 15_000,
    consecutiveFailureLimit: 3,
    restartPollingDelay: 30_000
  },
  zTrakBatteryAlertPct: 0.1,
  apiRequestPageSize: 5000,
  datadogSite: 'us5.datadoghq.com',
  minimumTripMS: 60000,
  featureFlags: {
    assetIOs: false
  },
  region: 'NA',
  gtcxUrl: {
    activityFeedUrl: 'https://activity-feed-ui.dev.zonarsystems.net/',
    assetLocator: 'https://asset-locator.dev.zonarsystems.net/'
  },
  i18n: {
    supportedLanguages: ['en-US', 'de-DE', 'en-GB', 'es-ES', 'fr-FR', 'it-IT'],
    defaultLanguage: 'en-US'
  },
  l10n,
  hamburgerMenuEnabled: true
};
